exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#licenses[data-v-62e7b090]{margin:15px 10%\n}\n@media(max-width: 945px){\n#licenses[data-v-62e7b090]{margin-left:5px;margin-right:5px\n}\n}\n.on-left[data-v-62e7b090]{margin-top:-8px;margin-right:5px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-62e7b090","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/license/list.vue
// module id = 169
// module chunks = 0